query sessionRecommendations($scenarioId: ID!, $originId: ID!, $sessionIds: [ID!]) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    sessionRecommendations(sessionIds: $sessionIds) {
      recommendation {
        process_id
        session {
          id
          blocksCount
          assignment {
            intervals {
              id
              name
              startingDate
              endingDate
              __typename
            }
            __typename
          }
          links {
            id
            packages {
              id
              code
              complete
              vacancies
              __typename
            }
            __typename
          }
          __typename
        }
        alternatives {
          days {
            id
            code
            name
          }
          start_time
          instructors {
            code
            id
            name
            usable
          }
          assignedInstructors {
            code
            id
            name
            usable
          }
          classrooms {
            id
            code
            capacity
            allowedOverflow
            name
            usable
            classroomType {
              id
              code
              name
            }
            building {
              id
              code
              name
              campus {
                id
                code
                name
              }
            }
          }
          current_asignment_mark
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
